import { Box, Typography } from '@mui/material';
import { getValues } from '@core/utils/enum';
import { toProperCase } from '@core/utils/string';
import { ProductionStage } from '../../enum/productionStage';
import SectionBar from './SectionBar';
import {
  PRINT_BORDER,
  cellPaddingSx,
  darkCellSx,
  labelTypographySx,
} from './printStyles';

const STAGES = (getValues(ProductionStage) as ProductionStage[]).filter(
  (stage) => stage !== ProductionStage.Queued
);

const stageLabel = (stage: ProductionStage) =>
  stage === ProductionStage.Completed ? 'Done' : toProperCase(stage);

const WRITE_IN_HEIGHT = 30;

const MonitoringStrip = () => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `auto repeat(${STAGES.length}, 1fr)`,
    }}
  >
    <Box
      sx={{
        ...darkCellSx,
        ...cellPaddingSx,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ ...labelTypographySx, letterSpacing: 1 }}>
        Monitoring
      </Typography>
    </Box>
    {STAGES.map((stage) => (
      <Box
        key={stage}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          borderLeft: PRINT_BORDER,
        }}
      >
        <SectionBar title={stageLabel(stage)} centered />
        <Box sx={{ height: WRITE_IN_HEIGHT }} />
      </Box>
    ))}
  </Box>
);

export default MonitoringStrip;
